{
  "$schema": "https://mux.run/theme.json",
  "name": "Nord",
  "id": "nord",
  "light": {
    "palette": {
      "neutral": "#eceff4",
      "ink": "#2e3440",
      "primary": "#5e81ac",
      "accent": "#bf616a",
      "success": "#8fbcbb",
      "warning": "#d08770",
      "error": "#bf616a",
      "info": "#81a1c1",
      "diffAdd": "#a3be8c",
      "diffDelete": "#bf616a"
    },
    "overrides": {
      "syntax-comment": "#6b7282",
      "syntax-keyword": "#5e81ac",
      "syntax-string": "#6f8758",
      "syntax-primitive": "#5e81ac",
      "syntax-constant": "#8d6886"
    }
  },
  "dark": {
    "palette": {
      "neutral": "#2e3440",
      "ink": "#e5e9f0",
      "primary": "#88c0d0",
      "accent": "#d57780",
      "success": "#a3be8c",
      "warning": "#d08770",
      "error": "#bf616a",
      "info": "#81a1c1",
      "diffAdd": "#81a1c1",
      "diffDelete": "#bf616a"
    },
    "overrides": {
      "syntax-comment": "#616e88",
      "syntax-keyword": "#81a1c1",
      "syntax-primitive": "#88c0d0",
      "syntax-constant": "#b48ead"
    }
  }
}
